import { useAnchorable } from '../../hooks/useAnchorable';
import { numberedList, numberedListContainer } from './NumberedList.css';
import type { PostNumberedListProps } from './NumberedList.types';

export const PostNumberedList = ({ element, children, ...props }: PostNumberedListProps) => {
  const { anchorAttributes } = useAnchorable(element.attrs);

  return (
    <div {...anchorAttributes} className={numberedListContainer}>
      <ol
        {...props}
        className={numberedList}
        {...(typeof element.attrs?.start === 'number' && { start: element.attrs.start })}
      >
        {children}
      </ol>
    </div>
  );
};
